module.exports = __webpack_public_path__ + "media/images/social/instagram-36f4d3828e47ce70bdfc9143008c197f.png";